import { createTheme } from "@mui/material/styles";
import { focusVisibleThemeComponents } from "@3sc/common-component";

const commonTypography = {
  fontFamily: "Euclid Circular Regular, sans-serif",
  fontSize: 12,
  fontWeightMedium: "bold",
  fontWeightRegular: "lighter",
};

const commonBrandColor = {
  grey2: "#474849",
  grey1: "#D7D7D7",
  main: "#FF6D33",
  grey3: "#898A93",
  blue: "#2176FF",
  red: "#E85353",
};

const commonComponents = {
  // `disableRipple` is a ButtonBase prop — Drawer has no ripple to disable,
  // so MuiDrawer never consumed it and it fell through onto the Drawer
  // root's plain `<div>`, triggering React's unknown-DOM-attribute warning.
  // MuiButtonBase is what actually disables ripple app-wide, for every
  // component built on it (Button, IconButton, ListItemButton, ...).
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  ...focusVisibleThemeComponents,
};

const getTheme = (mode) => {
  const isLight = mode === "light";
  return createTheme({
    palette: {
      mode,
      primary: {
        parentBackground: isLight ? "#FFFFFF" : "#101010",
        main: "#f5f7fa",
        background: isLight ? "#F8FAFB" : "#1D1D1D",
        textColor: isLight ? "#525252" : "#A8A8A8",
        activeText: isLight ? "#282A2A" : "#FFFFFF",
        borderColor: isLight ? "#D0D4DA" : "#313133",
        tooltipBackground: "#07080B",
        tooltipBorder: "#1A1B1D",
        activeBorderColor: "#E94F1C",
        iconColor: isLight ? "#666D80" : "#909090",
      },
      brandColor: commonBrandColor,
    },
    typography: commonTypography,
    components: commonComponents
  });
};

export const customTheme = {
  light: getTheme("light"),
  dark: getTheme("dark")
};
